/**
 * @generated SignedSource<<14c929abe8e8e5da84b52ec0fc4a7244>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineStoreCustomizeSections_routineSection$data = {
  readonly canBeDisabled: boolean;
  readonly id: string;
  readonly tasks: ReadonlyArray<{
    readonly __typename: "RoutineTaskListSectionTask";
  }>;
  readonly title: string | null;
  readonly " $fragmentType": "RoutineStoreCustomizeSections_routineSection";
};
export type RoutineStoreCustomizeSections_routineSection$key = {
  readonly " $data"?: RoutineStoreCustomizeSections_routineSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineStoreCustomizeSections_routineSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineStoreCustomizeSections_routineSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineTaskListSectionTask",
      "kind": "LinkedField",
      "name": "tasks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeDisabled",
      "storageKey": null
    }
  ],
  "type": "RoutineTaskListSection",
  "abstractKey": null
};

(node as any).hash = "7b5bb495abb29b9976920eff88c94b7b";

export default node;
